import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var QuaterlyTargetOneRes;
export const QuaterlyTargetOneTodo = createAsyncThunk('QuaterlyTargetOne', async (data) => {
    

    var type = localStorage.getItem('type')
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'quarterly_target_list',
            headers: { "Content-Type": "application/json" },
            data:
            {
                "vcust_plant_code": localStorage.getItem('vcust_plant_code'),
                "ibusiness_area_id": localStorage.getItem('ibusiness_area_id'),
                "iquater_id": "1",
                "iyear": '',
                "fin_year": localStorage.getItem('vfin_year').toString()

            }
        })
        return QuaterlyTargetOneRes = res.data

    } catch (error) {
        return QuaterlyTargetOneRes = error.response.data
    }
});

const QuaterlyTargetOneSlice = createSlice({
    name: 'QuaterlyTargetOne',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(QuaterlyTargetOneTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(QuaterlyTargetOneTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default QuaterlyTargetOneSlice.reducer; 